/**
 * @ngdoc directive
 * @name directiveErrorLightBox
 * @restrict A
 *
 * @description
 * Directive for myRatings error lightBox
 *
 * @element ANY
 */

export default function () {
    return {
        restrict: 'E',
        template: `<div class="pr-errorLightbox__wrapper"
                        data-ng-click="hideErrorLightBox()">
                        <div class="pr-errorLightbox_container"
                             data-ng-click="stopPropagation($event)">
                            <div class="pr-errorLightbox__header">
                                <div class="ui-btn ui-btn_small"
                                     data-ng-click="hideErrorLightBox()">
                                    <svg class="ui-icon
                                                ui-icon_sizeMedium">
                                        <use xlink:href="img/icons.svg#icon-cross"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="pr-errorLightbox__content">
                                Something's gone wrong
                                and your changes could not be saved.
                                Press save to try again.
                            </div>
                            <div class="pr-errorLightbox__button
                                        ui-btn ui-btn_primary"
                                  data-ng-click="hideErrorLightBox()">
                                Ok
                            </div>
                        </div>
                    </div>`
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/errorLightBox.js